// Bilingual UI strings
export const S = {
  brand: { en: "Nikunj Ittar Wale", hi: "निकुंज इत्र वाले" },
  brandSub: { en: "Vrindavan · Since Generations", hi: "वृन्दावन · पीढ़ियों से" },
  waConcierge: { en: "WhatsApp", hi: "व्हाट्सएप" },
  enquire: { en: "Enquire", hi: "पूछताछ" },
  enquireWa: { en: "Enquire on WhatsApp", hi: "व्हाट्सएप पर पूछें" },
  askWa: { en: "Ask on WhatsApp", hi: "व्हाट्सएप पर पूछें" },
  addToCart: { en: "Enquire Now", hi: "अभी पूछें" },
  explore: { en: "Explore", hi: "देखें" },

  hero: {
    badge: { en: "The Royal Perfumery of Braj", hi: "ब्रज की राजसी इत्र परंपरा" },
    l1: { en: "The Fragrance of Tradition,", hi: "परंपरा की सुगंध," },
    l2: { en: "The Elegance of Devotion", hi: "भक्ति की भव्यता" },
    sub: { en: "Discover timeless ittar, divine essentials and beautifully crafted poshaks inspired by the rich traditions of India.", hi: "भारत की समृद्ध परंपराओं से प्रेरित कालातीत इत्र, दिव्य सामग्री व सुंदर पोशाक की खोज करें।" },
    cta1: { en: "Explore Collection", hi: "संग्रह देखें" },
    cta2: { en: "Discover Our Story", hi: "हमारी कहानी" },
  },

  marquee: { en: "Shuddh Chandan · Gulab Khas · Ruh Khus · Thakur Ji Poshak · Vrindavan Seva · Kasturi Shamama · Laddu Gopal Shringar", hi: "शुद्ध चंदन · गुलाब खास · रूह खस · ठाकुर जी पोशाक · वृन्दावन सेवा · कस्तूरी शमामा · लड्डू गोपाल श्रृंगार" },

  about: {
    overline: { en: "Our Story", hi: "हमारी कहानी" },
    heading: { en: "A Tradition Woven Into Every Fragrance", hi: "हर सुगंध में बुनी एक परंपरा" },
    p1: { en: "Nikunj Ittar Wale brings together traditional Indian fragrances, devotional essentials and handcrafted poshaks — with an unwavering focus on quality, beauty and devotion.", hi: "निकुंज इत्र वाले पारंपरिक भारतीय सुगंध, भक्ति सामग्री व हस्तनिर्मित पोशाक को एक साथ लाता है — गुणवत्ता, सुंदरता व भक्ति पर अटूट ध्यान के साथ।" },
    p2: { en: "From the rose fields of Kannauj to the karigars of Braj, every creation carries the soul of India's heritage into your home and mandir.", hi: "कन्नौज के गुलाब के खेतों से लेकर ब्रज के कारीगरों तक, हर रचना भारत की विरासत की आत्मा को आपके घर व मंदिर तक लाती है।" },
    stat1: { en: "Pure & Alcohol-Free", hi: "शुद्ध व अल्कोहल-रहित" },
    stat2: { en: "Years of Legacy", hi: "वर्षों की विरासत" },
    stat3: { en: "Custom Poshak Crafting", hi: "कस्टम पोशाक निर्माण" },
  },

  collections: {
    overline: { en: "Boutique", hi: "बुटीक" },
    heading: { en: "Explore Our Collections", hi: "हमारे संग्रह देखें" },
  },

  ittar: {
    overline: { en: "Signature", hi: "विशिष्ट" },
    heading: { en: "The Art of Ittar", hi: "इत्र की कला" },
    sub: { en: "Timeless fragrances crafted to bring the essence of tradition into every sacred moment.", hi: "हर पवित्र क्षण में परंपरा का सार लाने हेतु बनाई गई कालातीत सुगंध।" },
  },

  puja: {
    overline: { en: "Devotion", hi: "भक्ति" },
    heading: { en: "For Every Sacred Moment", hi: "हर पवित्र क्षण के लिए" },
    sub: { en: "Pure chandan, ittar and essentials to elevate your daily seva.", hi: "आपकी दैनिक सेवा को उन्नत करने हेतु शुद्ध चंदन, इत्र व सामग्री।" },
  },

  poshak: {
    overline: { en: "Poshak Atelier", hi: "पोशाक एटलियर" },
    heading: { en: "Dressed in Devotion", hi: "भक्ति में सज्जित" },
    sub: { en: "Beautifully crafted poshaks created to add grace, colour and devotion to every divine darshan.", hi: "हर दिव्य दर्शन में गरिमा, रंग व भक्ति जोड़ने हेतु सुंदरता से बनाई पोशाक।" },
    cta: { en: "Explore Poshaks", hi: "पोशाक देखें" },
  },

  custom: {
    overline: { en: "Bespoke", hi: "विशेष निर्मित" },
    heading: { en: "Created Especially For Your Thakur Ji", hi: "विशेष रूप से आपके ठाकुर जी के लिए" },
    sub: { en: "Request a customised poshak tailored to size, colour, fabric, design and occasion — crafted just for your beloved deity.", hi: "आकार, रंग, कपड़ा, डिज़ाइन व अवसर अनुसार कस्टम पोशाक का अनुरोध करें — आपके प्रिय विग्रह हेतु विशेष।" },
    cta: { en: "Create Your Custom Poshak", hi: "अपनी कस्टम पोशाक बनाएं" },
    fName: { en: "Your Name", hi: "आपका नाम" },
    fPhone: { en: "Phone / WhatsApp", hi: "फ़ोन / व्हाट्सएप" },
    fDeity: { en: "Deity", hi: "विग्रह" },
    fSize: { en: "Size (inches / no.)", hi: "आकार (इंच / नंबर)" },
    fFabric: { en: "Preferred Fabric", hi: "पसंदीदा कपड़ा" },
    fColor: { en: "Preferred Colour", hi: "पसंदीदा रंग" },
    fOccasion: { en: "Occasion / Festival", hi: "अवसर / त्योहार" },
    fDetails: { en: "Additional Details", hi: "अतिरिक्त विवरण" },
    submit: { en: "Send Request", hi: "अनुरोध भेजें" },
    sending: { en: "Sending...", hi: "भेजा जा रहा है..." },
    success: { en: "Request received! We will contact you shortly.", hi: "अनुरोध प्राप्त हुआ! हम शीघ्र संपर्क करेंगे।" },
    orWa: { en: "Or send details on WhatsApp", hi: "या व्हाट्सएप पर विवरण भेजें" },
  },

  mukut: {
    overline: { en: "Shringar", hi: "श्रृंगार" },
    heading: { en: "The Royal Shringar Collection", hi: "राजसी श्रृंगार संग्रह" },
    sub: { en: "Handcrafted mukut, har and ornaments to complete a truly royal darshan.", hi: "वास्तविक राजसी दर्शन पूर्ण करने हेतु हस्तनिर्मित मुकुट, हार व आभूषण।" },
  },

  why: {
    overline: { en: "Why Choose Us", hi: "हमें क्यों चुनें" },
    heading: { en: "Crafted With Purpose & Purity", hi: "उद्देश्य व शुद्धता से निर्मित" },
  },

  featured: {
    overline: { en: "Handpicked", hi: "चयनित" },
    heading: { en: "Curated With Care", hi: "प्रेम से चयनित" },
  },

  testimonials: {
    overline: { en: "Testimonials", hi: "प्रशंसापत्र" },
    heading: { en: "Loved By Devotees", hi: "भक्तों द्वारा सराहा गया" },
  },

  gallery: {
    overline: { en: "Instagram", hi: "इंस्टाग्राम" },
    heading: { en: "Follow Our Journey", hi: "हमारी यात्रा देखें" },
    cta: { en: "Follow Us on Instagram", hi: "इंस्टाग्राम पर फ़ॉलो करें" },
  },

  contact: {
    overline: { en: "Get In Touch", hi: "संपर्क करें" },
    heading: { en: "We Would Love To Hear From You", hi: "हम आपसे सुनना पसंद करेंगे" },
    sub: { en: "Reach out for orders, custom poshaks or any devotional enquiry.", hi: "ऑर्डर, कस्टम पोशाक या किसी भी भक्ति संबंधी पूछताछ हेतु संपर्क करें।" },
    waBtn: { en: "Chat With Us on WhatsApp", hi: "व्हाट्सएप पर हमसे बात करें" },
    fName: { en: "Name", hi: "नाम" },
    fPhone: { en: "Phone", hi: "फ़ोन" },
    fEmail: { en: "Email (optional)", hi: "ईमेल (वैकल्पिक)" },
    fMsg: { en: "Your Message", hi: "आपका संदेश" },
    send: { en: "Send Enquiry", hi: "पूछताछ भेजें" },
    sending: { en: "Sending...", hi: "भेजा जा रहा है..." },
    success: { en: "Thank you! Your enquiry has been sent.", hi: "धन्यवाद! आपकी पूछताछ भेज दी गई है।" },
    phone: { en: "Phone", hi: "फ़ोन" },
    email: { en: "Email", hi: "ईमेल" },
    address: { en: "Visit Us", hi: "हमसे मिलें" },
  },

  footer: {
    desc: { en: "A premium Indian heritage boutique of ittar, puja essentials and handcrafted poshaks — rooted in tradition, devotion and craftsmanship.", hi: "इत्र, पूजा सामग्री व हस्तनिर्मित पोशाक का प्रीमियम भारतीय विरासत बुटीक — परंपरा, भक्ति व शिल्पकला में निहित।" },
    quickLinks: { en: "Quick Links", hi: "त्वरित लिंक" },
    collections: { en: "Collections", hi: "संग्रह" },
    contact: { en: "Contact", hi: "संपर्क" },
    rights: { en: "All rights reserved.", hi: "सर्वाधिकार सुरक्षित।" },
    privacy: { en: "Privacy Policy", hi: "गोपनीयता नीति" },
    terms: { en: "Terms & Conditions", hi: "नियम व शर्तें" },
    shipping: { en: "Shipping Policy", hi: "शिपिंग नीति" },
    returns: { en: "Return Policy", hi: "वापसी नीति" },
    home: { en: "Home", hi: "मुख्य पृष्ठ" },
    about: { en: "About", hi: "परिचय" },
  },
};
